// extracted by mini-css-extract-plugin
module.exports = {"wrap":"lj","heading":"mj","items":"nj","featureCss":"oj","disabled":"pj","imgCss":"qj"};